/* @flow */

import type { $WidgetAppliedSetting } from '../types/WidgetAppliedSetting';
import { getURLParams } from './WidgetUtils';

export default class WidgetSettings {

  widgetSettings: Object;
  widgetSettingsKeys: Object;
  appliedSettings: Array<$WidgetAppliedSetting<*>>;

  constructor(widgetSettingsKeys: Object, settings: Object) {
    this.widgetSettingsKeys = widgetSettingsKeys;
    this.widgetSettings = { ...settings, env: String(process.env.BUILD_ENV) };
    this.appliedSettings = [];
  }

  getWidgetSettings = () => {
    const settings: Object = {};
    Object.keys(this.widgetSettingsKeys).forEach((settingsKey: any) => {
      const setting = this.widgetSettingsKeys[settingsKey];
      const urlValue = getURLParams(setting.paramURL) || null;
      const appliedSetting = urlValue || this.widgetSettings[setting.skey] || setting.default || null;
      if (appliedSetting) settings[setting.skey] = appliedSetting;

      this.appliedSettings.push({
        property: setting.skey,
        URL: urlValue,
        settings: this.widgetSettings[setting.skey] || null,
        default: setting.default || null,
        applied: settings[setting.skey] || null
      });
    });
    settings.env = this.widgetSettings.env;
    return settings;
  }

  getAppliedSettings(): Array<$WidgetAppliedSetting<*>> {
    this.getWidgetSettings();
    return this.appliedSettings;
  }
}
